<template>
  <div class="page_content">
    <div class="row page-heading pg_hd" v-if="!embedded">
      <div class="col-7 input module_heading">
        <h1
            class="head_txt module_type_name ace_sec_hd">
              {{ $t('institution') }} : {{ institution.displayName }}
          </h1>
      </div>
    </div>
    <b-container fluid>
      <b-row class="page-content-section">
        <div class="left-container">
          <div class="employer-detail-title ace_sec_txt">
            <span class="ic_container">
              <span class="ic ic-inst" aria-hidden="true"></span>
            </span>
            <h1
              v-if="embedded"
              class="head_txt module_type_name ace_sec_hd">
              {{ institution.displayName }}
            </h1>
            <div
              v-else
              class="head_txt module_type_name ace_sec_hd">
              {{ institution.displayName }}
            </div>
          </div>
          <div class="employer-header-row">
            <div class="employer-meta">
              <div class="employer-meta-row">
                <div class="employer-meta-item">
                  <div class="icon_container">
                    <span class="icon-mail" aria-hidden="true"></span>
                  </div>
                  <div class="ace_sec_txt">{{ email }}</div>
                </div>
                <div class="employer-meta-item">
                  <div class="icon_container">
                    <span class="icon-phone" aria-hidden="true"></span>
                  </div>
                  <div class="ace_sec_txt">{{ phone }}</div>
                </div>
              </div>
              <div class="employer-meta-row address_row">
                <div class="employer-meta-item">
                  <div class="icon_container">
                    <span class="icon-location" aria-hidden="true"></span>
                  </div>
                  <div class="ace_sec_txt address-text">{{ address }}</div>
                </div>
              </div>
              <div class="employer-meta-row ace_sec_txt">
                <div class="employer-meta-item">
                  <div class="icon_container">
                    <span class="icon-checkmark status-approved" v-if="institutionStatus(institution) === 'Approved'" aria-hidden="true"></span>
                    <span class="ic24-hour-glass" v-else aria-hidden="true"></span>
                  </div>
                  <div class="ace_sec_txt">
                    {{ $t('status') }} : {{institutionStatus(institution)}}
                  </div>
                </div>
                <div class="employer-meta-item">
                  <div class="icon_container">
                    <span class="icon-user" aria-hidden="true"></span>
                  </div>
                  <div class="ace_sec_txt">
                    {{ $t('statusUpdatedBy') }} : {{institutionStatusUpdatedBy(institution)}}
                  </div>
                </div>
              </div>
            </div>
            <div class="employer-logo" v-if="institution.logo">
              <img :src="institution.logo" :alt="institution.displayName || ''"/>
            </div>
          </div>

          <div class="employer-meta-row description_row ace_sec_txt">
            <div class="employer-meta-item employer-description-item">
              <div class="icon_container">
                <span class="icon-paragraph-left" aria-hidden="true"></span>
              </div>
              <div>
                <h2 class="head_txt module_type_name ace_sec_hd">
                  {{ $t('description') }} :
                </h2>
              </div>
            </div>
          </div>
          <div class="employer-meta-row description_row ace_sec_txt">
            <div class="employer-meta-item employer-description-item">
              <div class="job-description" v-if="institution.description" v-html="institution.description"></div>
              <div v-else class="no-description">{{ $t('noDescriptionForInstitution') }}</div>
            </div>
          </div>
          <div class="row url-row" v-if="institution.externalUrl">
            <div class="col-12 column-content">
              <span class="icon-link col-left" aria-hidden="true"></span>
              <span class="col-right long_url">
                <b-link :href="institution.externalUrl" :title="institution.externalUrl" target="_blank">{{institution.externalUrl}}</b-link>
              </span>
            </div>
          </div>
        </div>
      </b-row>
    </b-container>
  </div>
</template>

<script>
  import '../../../assets/module/css/job/jobHomepage.min.css'
  import { mapState, mapActions } from 'vuex'

  export default {
    name: 'employerInstitutionDetails',
    props: {
      uuid: {
        type: String,
        default: ''
      },
      embedded: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        institution: {}
      }
    },
    mounted () {
      this.loadInstitution()
    },
    methods: {
    ...mapActions([
        'loadEmployerOrgInfo',
        'storeSelectedFactes'
      ]),
      loadInstitution () {
        if (!this.uuid) {
          this.institution = {}
          return
        }
        this.loadEmployerOrgInfo(this.uuid).then(res => {
          this.institution = res || {}
        })
      },
      institutionStatus (result){
        for (let i = 0; i < result.institutionEmployerMapping.length; i++) {
            let empMapping = result.institutionEmployerMapping[i]
            if(this.currentEmployer.uuid===empMapping.employerId){
                return empMapping.status
            }
        }
        return ''
      },
      institutionStatusUpdatedBy (result){
        for (let i = 0; i < result.institutionEmployerMapping.length; i++) {
            let empMapping = result.institutionEmployerMapping[i]
            if(this.currentEmployer.uuid===empMapping.employerId){
                return empMapping.statusUpdatedByName
            }
        }
        return ''
      }
    },
    computed: {
      ...mapState({
        'currentEmployer' : state => state.institution.institution
      }),
      phone () {
        return this.institution.phonenumber || this.$t('na')
      },
      email () {
        return this.institution.contactEmail || this.$t('na')
      },
      address () {
        return this.institution.address || this.$t('na')
      }
    },
    watch: {
      uuid () {
        this.loadInstitution()
      }
    }
  }
</script>

<style scoped>
    .page-content-section .left-container {
      float: none;
      width: 100%;
      max-width: 100%;
      margin-top: 0;
    }





    .employer-header-row {
      display: flex;
      align-items: center;
      width: 100%;
      min-width: 0;
      margin-bottom: 16px;
    }

    .employer-logo {
      flex: 0 0 auto;
      margin: 0 0 0 24px;
    }

    .employer-meta {
      flex: 1 1 auto;
      min-width: 0;
    }

    .employer-meta-row {
      display: grid;
      grid-template-columns: 1fr 1fr;
      column-gap: 0;
      align-items: center;
      width: 100%;
      margin-top: 10px;
      margin-bottom: 25px;
      margin-left:30px;
    }

    .employer-meta-row:last-child {
      margin-bottom: 0;
    }

    .address_row {
      grid-template-columns: 1fr;
    }


    .address-text {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }






    .employer-logo img {
      max-height: 80px;
      max-width: 240px;
      width: auto;
      height: auto;
    }

    .description_row {
      display: flex;
      grid-template-columns: none;
      min-height: 24px;
      margin-top: 16px;
      margin-bottom: 0;
    }

    .employer-description-item {
      width: 100%;
      white-space: normal;
    }

    .job-description {
      width: 100%;
      display: block;
      white-space: pre-wrap;
      word-wrap: break-word;
      margin-top: 0;
      margin-bottom: 24px;
      padding-left: 4em;
      line-height: 1.5;
    }

    .job-description >>> * {
      line-height: 1.5;
    }

    .no-description {
      margin-bottom: 24px;
      padding-left: 4em;
      line-height: 1.5;
    }
</style>



// WEBPACK FOOTER //
// src/app/job/components/EmployerInstitutionDetails.vue